module.exports = __webpack_public_path__ + "img/download__google.f8436d40.svg";